import { useFeatureGate } from '@statsig/react-bindings';

export default function useUsaOnly() {
  return useFeatureGate('usa_only').value;
}
